import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { buildAbsoluteUrl, getSiteUrl } from "../lib/seo";

const SITE_NAME = "Eclipse Tenis";
const DEFAULT_TITLE = "Eclipse Tenis | Tienda de tenis en Colombia";
const DEFAULT_DESCRIPTION =
  "Compra tenis y zapatillas en Colombia. Envio rapido, pago a cuotas y opciones a credito por WhatsApp.";

const Seo = ({
  title,
  description,
  canonical,
  image,
  type = "website",
  robots,
  jsonLd,
}) => {
  const location = useLocation();
  const siteUrl = getSiteUrl();
  const resolvedTitle = title ? `${title} | ${SITE_NAME}` : DEFAULT_TITLE;
  const resolvedDescription = description || DEFAULT_DESCRIPTION;
  const resolvedCanonical =
    canonical || (siteUrl ? `${siteUrl}${location.pathname}` : "");
  const resolvedImage = buildAbsoluteUrl(image || "/logo.png");
  const jsonLdItems = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

  return (
    <Helmet>
      <title>{resolvedTitle}</title>
      <meta name="description" content={resolvedDescription} />
      {resolvedCanonical ? (
        <link rel="canonical" href={resolvedCanonical} />
      ) : null}
      {robots ? <meta name="robots" content={robots} /> : null}

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={resolvedTitle} />
      <meta property="og:description" content={resolvedDescription} />
      {resolvedCanonical ? (
        <meta property="og:url" content={resolvedCanonical} />
      ) : null}
      {resolvedImage ? <meta property="og:image" content={resolvedImage} /> : null}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={resolvedTitle} />
      <meta name="twitter:description" content={resolvedDescription} />
      {resolvedImage ? <meta name="twitter:image" content={resolvedImage} /> : null}

      {jsonLdItems.map((item, index) => (
        <script
          key={`ld-${index}`}
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(item) }}
        />
      ))}
    </Helmet>
  );
};

export default Seo;
